import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useDialog } from '../../../hooks/use-dialog';
import { Center } from '../../../styles/center';
import { reset } from '../../../utils/styled-reset';
import { Button } from '../../button/button';
import { NewIntegrationDialog } from '../dialogs/new-integration-dialog/new-integration-dialog';
import { NoIntegrations } from '../no-integrations';
import { IntegrationListStatus, IntegrationsContext } from '../state/integrations-state';
import { IntegrationList } from './integration-list';

const IntegrationListContent = () => {
  const { t } = useTranslation();
  const { integrations, selectedIntegration, integrationStatus } =
    React.useContext(IntegrationsContext);
  const newIntegrationDialog = useDialog();

  return integrationStatus === IntegrationListStatus.Success ? (
    <Component>
      <Header>
        <Button color="primary" variant="contained" onClick={() => newIntegrationDialog.show()}>
          {t('integrationList.addIntegration', { ns: 'integrations' })}
        </Button>
      </Header>

      {integrations.length > 0 ? (
        <IntegrationList items={integrations} selectedItem={selectedIntegration} />
      ) : (
        <NoIntegrations />
      )}

      {newIntegrationDialog.render(
        <NewIntegrationDialog onClose={() => newIntegrationDialog.hide()} />,
      )}
    </Component>
  ) : (
    <Center>{t('oneMoment', { ns: 'common' })}</Center>
  );
};

const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1em;
`;

const Component = styled.div`
  ${reset}

  display: flex;
  flex-direction: column;
  padding: 2em;
  background-color: #fff;
`;

export { IntegrationListContent };
